import cplusplus from "./svg/c++.svg";
import css from "./svg/css.svg";
import firebase from "./svg/firebase.svg";
import git from "./svg/git.svg";
import html from "./svg/html.svg";
import java from "./svg/java.svg";
import js from "./svg/js.svg";
import php from "./svg/php.svg";
import python from "./svg/python.svg";
import react from "./svg/react.svg";
import shopify from "./svg/shopify.svg";
import sql from "./svg/sql.svg";
import tensorflow from "./svg/tensorflow.svg";
import twilio from "./svg/twilio.svg";
import typescript from "./svg/typescript.svg";
import wordpress from "./svg/wordpress.svg";


export const techs = [
    {name: "C++", image: cplusplus},
    {name: "CSS", image: css},
    {name: "HTML", image: html},
    {name: "Java", image: java},
    {name: "JavaScript", image: js},
    {name: "PHP", image: php},
    {name: "Python", image: python},
    {name: "React", image: react},
    {name: "Firebase", image: firebase},
    {name: "Shopify", image: shopify},
    {name: "Twilio", image: twilio},
    {name: "TensorFlow", image: tensorflow},
    {name: "WordPress", image: wordpress},
    {name: "SQL", image: sql},
    {name: "TypeScript", image: typescript},
    {name: "Git", image: git},
]